import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import "dayjs/locale/en-in";
import { TextField, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";

import dayjs from "dayjs";

// Utility function to format date without time
const formatDate = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};

const DatePick = ({ label, defaultValue, control, name, width, validation, maxDate, disableFuture, disablePast, disabled, isRequired }) => {
  const [reqDate, setReqDate] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate(defaultValue)));
    }
  }, [defaultValue]);

  return (
    <Controller
      name={name}
      defaultValue={reqDate}
      rules={{
        ...(validation?.required?.value && {
          validate: (value) => {
            if (!value) return validation?.required?.message;
            const selected = dayjs(value);
            if (!selected.isValid()) {
              return "Please select a valid date";
            }
            if (selected.year < 1950) {
              return "Please select a date after 1950";
            }
            if (selected.year > 2050) {
              return "Please select a date before 2050";
            }
            if (selected.month > 11) {
              return "Please select a valid month";
            }
            return !!value || validation?.required?.message;
          },
        }),
        ...(isRequired && {
          required: {
            value: true,
            message: "This field is required", // Custom message when required
          },
        }),
        ...(disablePast && {
          validate: (value) => {
            if (!value) return true;
            const today = dayjs().startOf("day");
            const selected = dayjs(value).startOf("day");
            return !selected.isBefore(today) || "Past dates are not allowed";
          },
        }),
      }}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl sx={{ width: width || "18.25vw", borderRadius: "1px" }} size="small" error={!!error}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
            <DatePicker
              name={name}
              slotProps={{
                textField: {
                  error: !!error,
                  // helperText: error?.message,
                  sx: {
                    width: width || "18.25vw",
                    borderRadius: "1px",
                    "& .MuiInputBase-root": {
                      height: "30px",
                    },
                  },
                },
              }}
              label={label}
              value={value ? dayjs(value) : reqDate}
              // sx={{ width: width ? width : "18.25vw", borderRadius: "1px", height: "30px" }}

              onChange={(event) => {
                if (event) {
                  const formattedDate = formatDate(event);
                  onChange(formattedDate);
                } else {
                  onChange(null);
                }
              }}
              disableFuture={disableFuture}
              disablePast={disablePast}
              disabled={disabled}
              maxDate={maxDate}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  error={!!error}
                  helperText={error ? error.message : null}
                  // sx={{
                  //   width: width ? width : "18.25vw",
                  //   borderRadius: "1px",
                  //   "& .MuiInputBase-root": {
                  //     // Target the parent container of the input
                  //     height: "30px",
                  //   },
                  // }}
                />
              )}
            />
          </LocalizationProvider>
          {error && (
            <Typography variant="caption" className="error-message">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};

export default DatePick;
